import React from 'react';

function SectionHeader ({ sectionLabel, className }) {
  return (
    <div className={className}>
      <span>{sectionLabel}</span>
    </div>
  )
}

export default SectionHeader;